import './HowItWorks.css'
import React from 'react'
import { useState } from "react";
import Footer from '@components/Common/Footer/Footer'
import Header from '@components/Common/Header/Header'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import HowBan from '../../Assets/Images/HowBan.png'

const HowItWorks = () => {
    const handleMenuToggle = () => { };
    const [activeTab, setActiveTab] = useState("borrowers");
    const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
    const [selectedLenderFaqIndex, setSelectedLenderFaqIndex] = useState(0);

    return (
        <>
            <section className="banner-section inner-banner-section">
                <Header handleMenuToggle={handleMenuToggle} />
                {/* <Breadcrumb className='mt-5'>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>

                        <Breadcrumb.Item active>How it Works</Breadcrumb.Item>
                    </Breadcrumb> */}
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-6">
                            <div className="banner banner_inner ">
                                <h3>
                                    How <span className="instant">it works</span>
                                </h3>
                                <p className='text-light mb-0'>A Step-by-Step Guide to Securing Your Loan and Start Investing</p>
                            </div>
                        </div>
                        <div className="col-xxl-6">
                            <img src={HowBan} alt="" className='img-fluid fa-ban' />
                        </div>
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <div className="container">

                    <div className='text-center how-it-works-text'>
                        <h3>How does it work?</h3>
                        <p>Getting a loan or investing shouldn’t be complicated. At Lendriva, we’ve simplified
                            finance into a transparent, community-driven process. Whether you want to borrow or
                            everything happens in just a few simple steps – designed to be fast, flexible, and fair. </p>
                    </div>
                    {/* <div className="faq-tabs">
                        <button
                            className={activeTab === "borrowers" ? "active" : ""}
                            onClick={() => setActiveTab("borrowers")}
                        >
                            Borrowers
                        </button>
                        <button
                            className={activeTab === "lenders" ? "active" : ""}
                            onClick={() => setActiveTab("lenders")}
                        >
                            Lenders & Investors
                        </button>
                    </div> */}

                    {/* BORROWERS TAB CONTENT */}
                    {/* {activeTab === "borrowers" && (
                        <> */}
                    <div>
                        <div className="howitworks row">
                            <div className={`faq-box col-xxl-4  ${selectedFaqIndex === 0 ? "selected" : ""}`}
                                onClick={() => setSelectedFaqIndex(0)}>
                                <div className='svg-icons-box  d-flex align-items-center justify-content-center'>
                                    <div className="icon-right d-flex align-items-center justify-content-center">1</div>
                                </div>
                                <div className='text-center'>
                                    <h3>Create Your Account</h3>
                                    <p>Signing up is simple and secure. Complete the online registration process and undergo ID verification checks. We prioritize your safety by ensuring every profile is thoroughly verified.</p>
                                </div>
                                <div className='dashed-border'></div>
                            </div>
                            <div className={`faq-box col-xxl-4  ${selectedFaqIndex === 1 ? "selected" : ""}`}
                                onClick={() => setSelectedFaqIndex(1)}>
                                <div className='svg-icons-box  d-flex align-items-center justify-content-center'>
                                    <div className="icon-right second d-flex align-items-center justify-content-center">2</div>
                                </div>
                                <div className='text-center'>
                                    <h3>Apply in Minutes</h3>
                                    <p>Tell us how much you need and why. Our application process is designed to be quick and straightforward, offering a fair and inclusive assessment of your financial profile. </p>
                                </div>
                                <div className='dashed-border both'></div>
                            </div>
                            <div className={`faq-box col-xxl-4  ${selectedFaqIndex === 2 ? "selected" : ""}`}
                                onClick={() => setSelectedFaqIndex(2)}>
                                <div className='svg-icons-box  d-flex align-items-center justify-content-center'>
                                    <div className="icon-right third d-flex align-items-center justify-content-center">3</div>
                                </div>
                                <div className="text-center">
                                    <h3>Review Your Offer</h3>
                                    <p>Receive a personalized rate and term tailored to your needs. We communicate transparently, avoiding complicated jargon or unnecessary pressure, so you can make an informed decision.</p>
                                </div>
                                <div className='dashed-border both last'></div>
                            </div>
                            <div className="col-xxl-3 "></div>
                            <div className="col-xxl-6 ">
                                <div className="row">
                                    <div className="col-xxl-6 ">
                                        <div className={`faq-box ${selectedFaqIndex === 4 ? "selected" : ""}`}
                                            onClick={() => setSelectedFaqIndex(4)}>
                                            <div className='svg-icons-box  d-flex align-items-center justify-content-center'>
                                                <div className="icon-right fifth d-flex align-items-center justify-content-center">5</div>
                                            </div>
                                            <div className="text-center">
                                                <h3>Repay with Ease</h3>
                                                <p>Manage your repayments effortlessly through your dashboard. With automated reminders, you’ll stay organized and on track throughout the repayment process.</p>
                                            </div>
                                            <div className='dashed-border four-dash'></div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 ">
                                        <div className={`faq-box ${selectedFaqIndex === 3 ? "selected" : ""}`}
                                            onClick={() => setSelectedFaqIndex(3)}>
                                            <div className='svg-icons-box  d-flex align-items-center justify-content-center'>
                                                <div className="icon-right fourth d-flex align-items-center justify-content-center">4</div>
                                            </div>
                                            <div className="text-center">
                                                <h3> Get Funded Fast</h3>
                                                <p>Once lenders approve your loan request, the funds are transferred directly to your bank account swiftly and efficiently.</p>
                                            </div>
                                            <div className='dashed-border both  last'></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-3 "></div>
                        </div>
                    </div>
                    {/* </>
                    )} */}

                    {/* LENDERS TAB CONTENT */}
                    {/* {activeTab === "lenders" && (
                        <> */}
                    {/* <div className="faq-grid howitworks">
                                <div className={`faq-box green-theme ${selectedLenderFaqIndex === 0 ? "selected" : ""}`}
                                    onClick={() => setSelectedLenderFaqIndex(0)}>
                                    <div className='svg-icons-box  d-flex align-items-center justify-content-between'>
                                        <div className="icon-left d-flex align-items-center justify-content-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="30"
                                                height="30"
                                                viewBox="0 0 512 512"
                                                xmlSpace="preserve"
                                            >
                                                <g>
                                                    <path
                                                        d="M233.4 293.4H112.2C50.2 293.4 0 343.6 0 405.6c0 25 20.2 45.2 45.2 45.2h255.2c25 0 45.2-20.2 45.2-45.2 0-62-50.2-112.2-112.2-112.2z"
                                                        fill="#0044CB"
                                                    />
                                                    <circle cx="172.8" cy="161.3" r="100.1" fill="#0044CB" />
                                                    <path
                                                        d="M480.4 175.1h-41v-41c0-17.5-14.1-31.6-31.6-31.6s-31.6 14.1-31.6 31.6v41h-41c-17.4 0-31.6 14.1-31.6 31.6 0 17.4 14.1 31.6 31.6 31.6h41v41c0 17.4 14.1 31.6 31.6 31.6 17.4 0 31.6-14.1 31.6-31.6v-41h41c17.5 0 31.6-14.1 31.6-31.6 0-17.4-14.1-31.6-31.6-31.6z"
                                                        fill="#0044CB"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                        <div className="icon-right d-flex align-items-center justify-content-center">1</div>
                                    </div>
                                    <h3>Sign Up & Verify</h3>
                                    <p>Begin your journey by opening an account on our platform. As part of our commitment to security and compliance, you will need to pass our secure Know Your Customer (KYC) and Anti-Money Laundering (AML) checks.</p>
                                </div>
                                <div className={`faq-box green-theme ${selectedLenderFaqIndex === 1 ? "selected" : ""}`}
                                    onClick={() => setSelectedLenderFaqIndex(1)}>
                                    <div className='svg-icons-box  d-flex align-items-center justify-content-between'>
                                        <div className="icon-left d-flex align-items-center justify-content-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="30"
                                                height="30"
                                                viewBox="0 0 512 512"
                                            >
                                                <g>
                                                    <path
                                                        d="M0 310v187c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15V310zm452 127c0 8.284-6.716 15-15 15H75c-8.284 0-15-6.716-15-15v-82c0-8.284 6.716-15 15-15h362c8.284 0 15 6.716 15 15z"
                                                        fill="#0044CB"
                                                    />
                                                    <path
                                                        d="M90 370h332v52H90zM275.205 137.12c.657-3.909.926-13.224-9.896-17.781v32.121c5.625-3.222 8.985-8.92 9.896-14.34zM245.31 67.905c-3.052 2.34-4.734 5.883-5.313 8.956-.799 4.239.213 8.177 2.578 10.031a35.545 35.545 0 0 0 2.735 1.926z"
                                                        fill="#0044CB"
                                                    />
                                                    <path
                                                        d="M256 220c60.751 0 110-49.249 110-110S316.751 0 256 0 146 49.249 146 110s49.249 110 110 110zm-37.839-69.131c3.024-4.621 9.222-5.916 13.843-2.894 5.401 3.533 8.787 5.068 13.306 5.703v-42.234c-6.388-2.927-11.162-5.744-15.079-8.817-8.298-6.508-12.087-17.801-9.888-29.472 2.396-12.718 11.249-22.836 23.102-26.407a60.164 60.164 0 0 1 1.865-.526V40c0-5.522 4.477-10 10-10 5.522 0 10 4.478 10 10v5.127c9.708 1.681 16.572 6.46 19.895 10.276 3.628 4.164 3.192 10.481-.972 14.108-4.142 3.608-10.413 3.198-14.051-.905-.227-.231-1.817-1.761-4.872-2.887v32.312c1.775.659 3.549 1.298 5.29 1.914 17.578 6.214 27.355 22.486 24.329 40.491-2.353 13.995-13.003 28.188-29.619 32.403V180c0 5.522-4.478 10-10 10-5.523 0-10-4.478-10-10v-6.202c-8.074-.698-14.767-2.879-24.254-9.086-4.623-3.024-5.919-9.221-2.895-13.843z"
                                                        fill="#0044CB"
                                                    />
                                                    <path
                                                        d="M471.23 170.257A15 15 0 0 0 457 160h-70.238c-9.127 23.789-24.561 44.479-44.254 60H386c8.284 0 15 6.716 15 15s-6.716 15-15 15H126c-8.284 0-15-6.716-15-15s6.716-15 15-15h43.492c-19.693-15.521-35.127-36.211-44.254-60H55a15 15 0 0 0-14.23 10.257L4.189 280h503.623z"
                                                        fill="#0044CB"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                        <div className="icon-right d-flex align-items-center justify-content-center">2</div>
                                    </div>
                                    <h3>Deposit Funds</h3>
                                    <p> Once your account is verified, securely fund your wallet through our platform. Your money is safeguarded in a separate client account, offering you maximum protection and peace of mind.</p>
                                </div>
                                <div className={`faq-box green-theme ${selectedLenderFaqIndex === 2 ? "selected" : ""}`}
                                    onClick={() => setSelectedLenderFaqIndex(2)}>
                                    <div className='svg-icons-box  d-flex align-items-center justify-content-between'>
                                        <div className="icon-left d-flex align-items-center justify-content-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="30"
                                                height="30"
                                                viewBox="0 0 512.001 512.001"
                                            >
                                                <path
                                                    d="M507.607 364.387c-5.859-5.859-15.352-5.859-21.211 0l-4.395 4.395V224.994c0-11.567-4.508-22.02-11.704-30 
      7.196-7.98 11.704-18.433 11.704-30V51.208l4.394 4.394c5.859 5.859 15.352 5.859 21.211 0s5.859-15.352 0-21.211L477.624 
      4.409c-5.856-5.872-15.428-5.836-21.248 0L426.395 34.39c-5.859 5.859-5.859 15.352 0 21.211s15.352 5.859 21.211 
      0l4.395-4.395v113.788c0 8.276-6.724 15-15 15h-46.799C381.573 68.671 281.71-11.596 171.434 1.388 
      86.635 11.349 15.561 79.61 2.451 163.691c-9.785 62.738 10.005 124.276 54.301 168.821 21.445 21.548 
      33.252 48.734 33.252 76.522v87.956c0 8.291 6.709 15 15 15h179.998c8.291 0 15-6.709 
      15-15v-47h45c8.291 0 15-6.709 15-15V329.992h47c5.2 0 10.034-2.695 12.759-7.119a14.993 14.993 0 0 0 
      .659-14.604c-1.853-4.812-24.921-39.267-28.568-98.275h45.15c8.276 0 15 6.724 15 
      15v143.788l-4.395-4.395c-5.859-5.859-15.352-5.859-21.211 0s-5.859 15.352 0 
      21.211l29.982 29.982c2.814 2.822 6.733 4.413 10.624 4.413s7.809-1.591 
      10.624-4.413l29.982-29.982c5.857-5.859 5.857-15.352-.001-21.211zM290.422 
      290.414c-52.819 52.789-137.974 52.834-190.838 0-25.532-25.547-39.58-59.428-39.58-95.419 
      0-8.291 6.709-15 15-15s15 6.709 15 15c0 27.979 10.942 54.345 30.791 
      74.208 39.727 39.697 108.69 39.697 148.417 0 5.859-5.859 15.352-5.859 21.211 0 
      5.858 5.859 5.859 15.366-.001 21.211zm-72.949-134.399c-7.163-4.16-9.609-13.345-5.449-20.508 
      4.131-7.178 13.286-9.639 20.508-5.449 23.115 13.418 37.471 38.291 37.471 
      64.936 0 26.646-14.355 51.518-37.471 64.936-7.163 4.156-16.353 1.699-20.508-5.449 
      -4.16-7.163-1.714-16.348 5.449-20.508 13.901-8.057 22.529-22.998 
      22.529-38.979s-8.628-30.922-22.529-38.979zm-7.471 38.98c0 8.284-6.716 15-15 15-8.284 
      0-15-6.717-15-15 0-8.286 6.716-15 15-15 8.284 0 15 6.714 15 15zm-37.469-38.981c-13.901 
      8.057-22.529 22.998-22.529 38.979s8.627 30.925 22.529 38.981c7.163 4.16 9.609 
      13.345 5.449 20.508-4.162 7.163-13.359 9.597-20.508 5.449-23.115-13.418-37.471 
      -38.291-37.471-64.936s14.355-51.518 37.471-64.936c7.222-4.146 16.377-1.699 20.508 
      5.449 4.16 7.161 1.714 16.346-5.449 20.506zm142.468 53.981c-8.291 
      0-15-6.709-15-15 0-27.979-10.942-54.345-30.791-74.208-39.727-39.697-108.69 
      -39.697-148.417 0-5.859 5.859-15.352 5.859-21.211 0-5.859-5.859-5.859-15.366 0-21.211 
      52.819-52.788 137.974-52.834 190.838 0 25.532 25.547 39.58 59.428 39.58 
      95.419.001 8.291-6.708 15-14.999 15z"
                                                    fill="#0044CB"
                                                />
                                            </svg>
                                        </div>
                                        <div className="icon-right d-flex align-items-center justify-content-center">3</div>
                                    </div>
                                    <h3>Choose Your Strategy</h3>
                                    <p>Tailor your investment approach to suit your goals. You can manually select loans or use our Auto-Invest feature for smart matching based on your criteria.</p>
                                </div>
                                <div className={`faq-box green-theme ${selectedLenderFaqIndex === 3 ? "selected" : ""}`}
                                    onClick={() => setSelectedLenderFaqIndex(3)}>
                                    <div className='svg-icons-box  d-flex align-items-center justify-content-between'>
                                        <div className="icon-left d-flex align-items-center justify-content-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="30"
                                                height="30"
                                                viewBox="0 0 64 64"
                                            >
                                                <g data-name="Human Resource">
                                                    <circle cx="32" cy="8.38" r="4.361" fill="#0044CB" />
                                                    <path
                                                        d="M38.5 16.94v7.7a1.887 1.887 0 0 1-.5 1.28l-1.07 1.12v10.32a1.883 1.883 0 0 1-1.85 1.9h-6.16a1.883 1.883 0 0 1-1.85-1.9V27.04L26 25.92a1.887 1.887 0 0 1-.5-1.28v-7.7a3.07 3.07 0 0 1 .24-1.18 2.804 2.804 0 0 1 2.56-1.73h7.4a2.804 2.804 0 0 1 2.56 1.73 3.07 3.07 0 0 1 .24 1.18z"
                                                        fill="#0044CB"
                                                    />
                                                    <circle cx="41" cy="10.88" r="3.784" fill="#0044CB" />
                                                    <circle cx="23" cy="10.88" r="3.784" fill="#0044CB" />
                                                    <path
                                                        d="M46.56 18.34v6.38a1.683 1.683 0 0 1-.47 1.17l-.84.89v8.47a1.723 1.723 0 0 1-1.7 1.75h-4.62v-9.16l.52-.55a3.803 3.803 0 0 0 1.05-2.65v-7.7a4.597 4.597 0 0 0-.15-1.18h3.71a2.545 2.545 0 0 1 2.5 2.58zM24.55 27.29l.52.55V37h-4.62a1.723 1.723 0 0 1-1.7-1.75v-8.47l-.84-.89a1.683 1.683 0 0 1-.47-1.17v-6.38a2.545 2.545 0 0 1 2.5-2.58h3.71a4.597 4.597 0 0 0-.15 1.18v7.7a3.82 3.82 0 0 0 1.05 2.65z"
                                                        fill="#0044CB"
                                                    />
                                                    <rect width="14.5" height="7" x="14.68" y="52.98" rx="1" fill="#0044CB" />
                                                    <path
                                                        d="M27.83 50.98H15.68c-.11 0-.22.01-.33.02-.8-.89-2.84-2.78-8.74-8.53a4.405 4.405 0 0 1-1.27-2.56 62.812 62.812 0 0 1 .53-19.5.78.78 0 0 1 1.12-.55 7.052 7.052 0 0 1 3.65 8.75 2.813 2.813 0 0 0 .06 1.96 8.7 8.7 0 0 0 .4 1.39c-2.17.47-2.8 3.39-1.09 5.32l4.98 5.62a1 1 0 0 0 1.5-1.32l-4.99-5.63c-1.32-1.49.4-3.76 2.7-1.48 1.39 1.37 2.84 2.68 4.26 4.02.63.63 1.57.48 2.49.66a8.309 8.309 0 0 1 4.35 2.29c2.75 2.73 2.58 5.88 2.53 9.54z"
                                                        fill="#0044CB"
                                                    />
                                                    <rect width="14.5" height="7" x="34.82" y="52.98" rx="1" fill="#0044CB" />
                                                    <path
                                                        d="M58.66 39.91a4.405 4.405 0 0 1-1.27 2.56c-5.9 5.75-7.94 7.64-8.73 8.53h-.01c-.11-.01-.22-.02-.33-.02H36.17c-.05-3.66-.22-6.81 2.53-9.54a8.309 8.309 0 0 1 4.35-2.29c.89-.17 1.87-.04 2.49-.66 1.42-1.34 2.87-2.65 4.26-4.02 2.3-2.28 4.02-.01 2.7 1.48l-4.99 5.63a1 1 0 0 0 1.5 1.32l4.98-5.62c1.71-1.93 1.08-4.85-1.09-5.32a8.7 8.7 0 0 0 .4-1.39 2.813 2.813 0 0 0 .06-1.96 7.052 7.052 0 0 1 3.65-8.75.78.78 0 0 1 1.12.55 62.812 62.812 0 0 1 .53 19.5z"
                                                        fill="#0044CB"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                        <div className="icon-right d-flex align-items-center justify-content-center">4</div>
                                    </div>
                                    <h3>Support Real People</h3>
                                    <p>Every dollar you invest impacts someone’s life. Help others while earning monthly interest—a win-win.</p>
                                </div>
                                 Add more lender FAQs as needed 
                            </div> */}
                    {/* <p className='mt-4 have-ques'>Have more questions?<a href="javascript:void(0)"> Contact our team </a> —we’re always here to help.</p>
                        </>
                    )} */}

                </div>
            </section>

            <section className="borrow-section borrow-img">
                <div className="container">
                    <div className=" text-center borrow-img">
                        <h2 className="mt-0">Ready to Lend or Borrow?</h2>
                        <p>Start building your financial future today</p>
                        <div className="input-bloc text-center">
                            <input type="email" placeholder="Enter Your Email" />
                            <button className="btn-filled-blue-lan">
                                Subscribe
                            </button>
                            <p className="text-center m-0 borrow-para">We’ll never share your details with third parties.
                                View our Privacy Policy for more info.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footer />

        </>
    )
}

export default HowItWorks
